import React, { useContext } from "react";
import IKit_Builder_Option_ItemUI from "../../../../models/IKit_Builder_Option_ItemUI";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import HelperService from "../../../../services/HelperService";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    item: IKit_Builder_Option_ItemUI | Partial<IKit_Builder_Option_ItemUI>;
    subSelectFn: (
        parentItem: IKit_Builder_Option_ItemUI | Partial<IKit_Builder_Option_ItemUI>,
        subItem: IKit_Builder_Option_ItemUI
    ) => void;
    showPrice: boolean;
    priceGroupName: string | undefined;
};

export const KitBuilderSubItem = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const selectSubKitItem = (item: IKit_Builder_Option_ItemUI) => {
        props.subSelectFn(props.item, item);
    };

    return (
        <div className={"KitBuilderSubItem ms-4"}>
            <OwSelectOption
                valueProp={"id"}
                titleProp={""}
                titleRenderFn={(subKitBuilderOptionItem) => {
                    let title = `${subKitBuilderOptionItem.Catalog_Item?.name} - ${subKitBuilderOptionItem.Catalog_Item?.description}`;

                    if (props.showPrice && props.priceGroupName) {
                        title += ` - ${HelperService.formatCurrency({
                            value: subKitBuilderOptionItem.Catalog_Item?.pricing[props.priceGroupName],
                            currency: "USD",
                            precision: supplierModel.pricing_precision || 2,
                        })}`;
                    }

                    return title;
                }}
                fn={selectSubKitItem}
                name={"subKitItem"}
                options={props.item.Sub_Kit_Builder_Option_Items || []}
                autoSelectSingleOption={true}
                emitObject={true}
                emitOnLoad={false}
            />
        </div>
    );
};
